import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {},
  title: {
    color: theme.palette.black.dark,
    fontSize: '28px',
    fontWeight: 600,
    margin: 0,
  },
  subTitle: {
    fontSize: '20px',
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginTop: '10px',
    marginBottom: '16px'
  },
  text: {
    fontSize: '14px',
    color: theme.palette.grey.grey400
  },
  itemList: {
    display: 'flex',
    flexDirection: 'column'
  },
  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '15px',
  },
  tiersList: {
    maxHeight: '350px',
    overflow: 'auto'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    height: 'auto',
    width: 'auto',
    borderRadius: '7px',
    background: '#FFF',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
    marginBottom: '17px'
  },
  itemTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#4A4A4A',
    marginBottom: '5px'
  },
  contextWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  modelName: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey700
  },
  tpName: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.primary.primary800
  },
  tpActivity: {
    fontSize: '10px',
    color: theme.palette.grey.grey400,
    width: '220px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  reference: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.palette.grey.grey300
  }
}));

export default useStyles;
